<template>
  <div class="pt-10 mx-auto w-full md:w-2/3 xl:w-1/2">
    <p class="font-semibold text-center tracking-wider text-gray-500">
      STEP 2/5
    </p>
    <p class="mb-4 text-4xl font-semibold text-center tracking-widest">
      Quote Terms
    </p>
    <TermsForm />
  </div>
</template>

<script>
import TermsForm from "~/components/app/TermsForm";

export default {
  name: "Terms",

  components: {
    TermsForm
  }
};
</script>

<style></style>
